// Marcas y modelos de autos populares en Puerto Rico
export const marcasAutos: Record<string, string[]> = {
  Toyota: ['Camry', 'Corolla', 'RAV4', 'Tacoma', 'Tundra', 'Highlander', 'Prius', '4Runner', 'Yaris', 'Sequoia'],
  Hyundai: ['Elantra', 'Sonata', 'Tucson', 'Santa Fe', 'Accent', 'Kona', 'Palisade', 'Ioniq 5', 'Venue'],
  Kia: ['Sportage', 'Sorento', 'Forte', 'Soul', 'Telluride', 'Stinger', 'Carnival', 'EV6', 'Seltos'],
  Nissan: ['Altima', 'Sentra', 'Rogue', 'Pathfinder', 'Frontier', 'Murano', 'Kicks', 'Armada', 'Versa'],
  Ford: ['F-150', 'Explorer', 'Escape', 'Mustang', 'Edge', 'Bronco', 'Ranger', 'Expedition', 'Maverick'],
  Honda: ['Civic', 'Accord', 'CR-V', 'Pilot', 'HR-V', 'Ridgeline', 'Passport', 'Odyssey', 'Fit'],
};

// Marcas de camiones y vehículos pesados
export const marcasCamiones: Record<string, string[]> = {
  Isuzu: ['NPR', 'NQR', 'NRR', 'FTR', 'FVR', 'FXR', 'Elf'],
  Hino: ['195', '258', '268', '338', '500 Series', '700 Series', 'XL8'],
  Freightliner: ['Cascadia', 'M2 106', 'M2 112', 'Sprinter', 'Business Class M2', 'Columbia'],
};

export const categoriasCamiones = ['Furgón', 'Volteo', 'Plataforma', 'Refrigerado', 'Grúa', 'Cisterna'];

export const autosDestacadosMock = [
  {
    id: 'auto1',
    marca: 'Toyota',
    modelo: 'Tacoma',
    precio: 38500,
    imagen: 'https://public.readdy.ai/ai/img_res/3939b65e9dac94b77e488d8efd145ac5.jpg',
    anio: 2023,
    millaje: '18,200 mi',
    condicion: 'Usado',
    dealer: 'Toyota de Puerto Rico',
    ubicacion: 'San Juan',
    titulo_en_mano: true,
    garantia_dealer: false,
  },
  {
    id: 'auto2',
    marca: 'Honda',
    modelo: 'CR-V',
    precio: 32800,
    imagen: 'https://readdy.ai/api/search-image?query=Honda%20CR-V%202023%20white%20SUV%20front%20three%20quarter%20angle%20clean%20white%20studio%20background%20professional%20car%20photography%20dealership%20commercial%20automotive%20shot%20minimal&width=600&height=400&seq=auto-crv2&orientation=landscape',
    anio: 2023,
    millaje: '12,000 mi',
    condicion: 'Usado',
    dealer: 'Honda Premium Motors',
    ubicacion: 'Bayamón',
    titulo_en_mano: true,
    garantia_dealer: true,
  },
  {
    id: 'auto3',
    marca: 'Ford',
    modelo: 'F-150',
    precio: 45900,
    imagen: 'https://readdy.ai/api/search-image?query=Ford%20F-150%202024%20black%20pickup%20truck%20powerful%20front%20angle%20white%20studio%20background%20professional%20automotive%20photography%20clean%20dealership%20style%20commercial%20vehicle%20shot&width=600&height=400&seq=auto-f150-3&orientation=landscape',
    anio: 2024,
    millaje: '0 mi',
    condicion: 'Nuevo',
    dealer: 'Ford Island Motors',
    ubicacion: 'Ponce',
    titulo_en_mano: false,
    garantia_dealer: true,
  },
  {
    id: 'auto4',
    marca: 'Hyundai',
    modelo: 'Tucson',
    precio: 28400,
    imagen: 'https://readdy.ai/api/search-image?query=Hyundai%20Tucson%202023%20blue%20compact%20SUV%20three%20quarter%20front%20view%20pristine%20white%20studio%20background%20professional%20car%20photography%20dealership%20commercial%20quality%20shot&width=600&height=400&seq=auto-tucson4&orientation=landscape',
    anio: 2023,
    millaje: '15,800 mi',
    condicion: 'Usado',
    dealer: 'Hyundai Caribe',
    ubicacion: 'Caguas',
    titulo_en_mano: true,
    garantia_dealer: false,
  },
  {
    id: 'auto5',
    marca: 'Kia',
    modelo: 'Sportage',
    precio: 26900,
    imagen: 'https://readdy.ai/api/search-image?query=Kia%20Sportage%202022%20red%20compact%20crossover%20SUV%20side%20front%20angle%20clean%20white%20studio%20background%20professional%20automotive%20photography%20dealership%20commercial%20shot%20minimal%20setting&width=600&height=400&seq=auto-sportage5&orientation=landscape',
    anio: 2022,
    millaje: '24,500 mi',
    condicion: 'Usado',
    dealer: 'Kia Motors PR',
    ubicacion: 'Mayagüez',
    titulo_en_mano: true,
    garantia_dealer: false,
  },
  {
    id: 'auto6',
    marca: 'Nissan',
    modelo: 'Rogue',
    precio: 31200,
    imagen: 'https://readdy.ai/api/search-image?query=Nissan%20Rogue%202023%20gray%20SUV%20front%20three%20quarter%20angle%20white%20studio%20background%20professional%20car%20photography%20dealership%20commercial%20automotive%20shot%20clean%20minimal&width=600&height=400&seq=auto-rogue6&orientation=landscape',
    anio: 2023,
    millaje: '9,800 mi',
    condicion: 'Usado',
    dealer: 'Nissan de PR',
    ubicacion: 'Carolina',
    titulo_en_mano: false,
    garantia_dealer: true,
  },
];

export const camionesDestacadosMock = [
  {
    id: 'camion1',
    marca: 'Isuzu',
    modelo: 'NPR',
    categoria_camion: 'Furgón',
    precio: 42000,
    imagen: 'https://readdy.ai/api/search-image?query=Isuzu%20NPR%20box%20truck%20white%20commercial%20delivery%20vehicle%20side%20view%20clean%20white%20studio%20background%20professional%20commercial%20truck%20photography%20minimal%20setting&width=600&height=400&seq=camion-isuzu1&orientation=landscape',
    anio: 2021,
    millaje: '45,000 mi',
    condicion: 'Usado',
    vendedor: 'Camiones PR',
    ubicacion: 'Bayamón',
    titulo_en_mano: true,
    garantia_dealer: false,
  },
  {
    id: 'camion2',
    marca: 'Hino',
    modelo: '268',
    categoria_camion: 'Volteo',
    precio: 68000,
    imagen: 'https://readdy.ai/api/search-image?query=Hino%20268%20dump%20truck%20yellow%20commercial%20heavy%20vehicle%20side%20view%20clean%20white%20studio%20background%20professional%20truck%20photography%20minimal%20commercial%20setting&width=600&height=400&seq=camion-hino2&orientation=landscape',
    anio: 2022,
    millaje: '28,000 mi',
    condicion: 'Usado',
    vendedor: 'Heavy Trucks PR',
    ubicacion: 'Ponce',
    titulo_en_mano: true,
    garantia_dealer: true,
  },
  {
    id: 'camion3',
    marca: 'Freightliner',
    modelo: 'M2 106',
    categoria_camion: 'Plataforma',
    precio: 85000,
    imagen: 'https://readdy.ai/api/search-image?query=Freightliner%20M2%20106%20flatbed%20platform%20truck%20white%20commercial%20heavy%20vehicle%20side%20view%20clean%20white%20studio%20background%20professional%20truck%20photography%20minimal%20setting&width=600&height=400&seq=camion-freight3&orientation=landscape',
    anio: 2023,
    millaje: '12,000 mi',
    condicion: 'Usado',
    vendedor: 'Island Freight',
    ubicacion: 'San Juan',
    titulo_en_mano: false,
    garantia_dealer: true,
  },
];
